import { CLEAR_ALL_EXCEPT_ACCOUNT } from "../constants";
import * as browser from "./browser";
import * as currentDeal from "./currentDeal";
import * as deal from "./deal";
import * as garage from "./garageActions";
import * as onlineShopper from "./onlineShopper";
import * as openModal from "./openModal";
import * as rebates from "./conditionalRebates";
import * as updateModalSize from "./updateModalSize";
import * as userAccount from "./userAccount";

export const clearAllExceptAccount = () => ({ type: CLEAR_ALL_EXCEPT_ACCOUNT });

export { browser, currentDeal, deal, garage, openModal, onlineShopper, rebates, updateModalSize, userAccount };
